import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "shared-files-wrapper p-3" }
const _hoisted_2 = { class: "d-flex p-2" }
const _hoisted_3 = { class: "me-3" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Shared By", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "mb-3 table-wrapper" }
const _hoisted_9 = { class: "table table-borderless" }
const _hoisted_10 = { class: "bg-table-header" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Type ")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Uploaded ")
const _hoisted_19 = { key: 5 }
const _hoisted_20 = {
  key: 6,
  class: "d-none d-md-table-cell"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Uploaded By ")
const _hoisted_22 = {
  key: 7,
  class: "d-none d-md-table-cell"
}
const _hoisted_23 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_24 = ["colspan"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", null, "No Shared Files to Display", -1 /* HOISTED */)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ConversationSharedFileRow = _resolveComponent("ConversationSharedFileRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "fas fa-times dialog-close float-end mb-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogReference.close()))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.options.title), 1 /* TEXT */)
      ]),
      (_ctx.sharedFilesUsers?.length > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploaderId) = $event)),
              name: "selectSharedBy",
              class: "border-0"
            }, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedFilesUsers, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: user.userId,
                  key: user.userId
                }, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 9 /* TEXT, PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.uploaderId]
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", _hoisted_9, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_10, [
            (_ctx.assets?.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_11, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    "sort-order": _ctx.sortOrder,
                    "sort-string": "mimeType"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "sort-order"])
                ]))
              : (_openBlock(), _createElementBlock("th", _hoisted_13, "Type")),
            (_ctx.assets?.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_14, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    "sort-order": _ctx.sortOrder,
                    "sort-string": "fileName"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "sort-order"])
                ]))
              : (_openBlock(), _createElementBlock("th", _hoisted_16, "Name")),
            (_ctx.assets?.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_17, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    "sort-order": _ctx.sortOrder,
                    "sort-string": "modifiedDate"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "sort-order"])
                ]))
              : (_openBlock(), _createElementBlock("th", _hoisted_19, "Uploaded")),
            (_ctx.assets?.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_20, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    "sort-order": _ctx.sortOrder,
                    "sort-string": "uploaderLastName"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "sort-order"])
                ]))
              : (_openBlock(), _createElementBlock("th", _hoisted_22, "Uploaded By"))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!_ctx.isLoading && _ctx.assets?.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_26, 8 /* PROPS */, _hoisted_24)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.loadingCount, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: "table-loading"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (j) => {
                    return (_openBlock(), _createElementBlock("td", { key: j }, _hoisted_28))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        (!_ctx.isLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.assets, (asset) => {
              return (_openBlock(), _createElementBlock("tbody", {
                key: asset.id
              }, [
                _createVNode(_component_ConversationSharedFileRow, {
                  asset: asset,
                  columns: _ctx.columns
                }, null, 8 /* PROPS */, ["asset", "columns"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}